export enum PriceListItemType {
  ExamType = "examType",
  TestType = "testType",
  Survey = "survey",
  ServiceType = "serviceType",
}
